import Head from "next/head";

const url = "https://www.venturawebdesign.com";

const MetaTags = ({ pageTitle, pageDescription, path, isHome }) => (
  <Head>
    <title>{isHome ? "Ventura Web Design & Marketing - Ecommerce Agency" : pageTitle + " | " + "Ventura Web Design"}</title>
    <meta
      name="description"
      content={
        pageDescription ||
        "Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa."
      }
    />

    <link rel="canonical" href={url + path} />

    <meta property="og:url" content={url + path} />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={pageTitle || "Ventura Web Design & Marketing" + (pageTitle.length > 0 ? "| Ventura Web Design & Marketing" : "")} />
    <meta
      property="og:description"
      content={
        pageDescription ||
        "Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa."
      }
    />
    <meta property="og:image" content="/ventura-og.png" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta property="twitter:domain" content="venturawebdesign.com" />
    <meta property="twitter:url" content={url + path} />
    <meta name="twitter:title" content={pageTitle || "Ventura Web Design & Marketing" + (pageTitle.length > 0 ? "| Ventura Web Design & Marketing" : "")} />
    <meta
      name="twitter:description"
      content={
        pageDescription ||
        "Ventura Web Design & Marketing is a web design and development company that creates and builds professional websites including high quality e-commerce stores with offices in Las Vegas and Tampa."
      }
    />
    <meta name="twitter:image" content="/ventura-og.png" />
  </Head>
);

export default MetaTags;